import { useDeviceStore } from '@namespace/device';
import { COOKIES_KEYS, getCookie } from '@namespace/helpers';
import { nativeAppActions } from '../../store/actions';
import { useNativeAppStore } from '../../store/store';

export const useMobilePWABanner = () => {
  const { visiblePWAInstructions } = useNativeAppStore();
  const { SET_PWA_INSTRUCTIONS } = nativeAppActions;

  const isPWABannerDisabled = getCookie(
    COOKIES_KEYS.IS_MOBILE_PWA_BANNER_DISABLED,
    false
  );
  const { isMobile, isTablet, isPWA } = useDeviceStore();

  return {
    isShowPWABanner: !isPWA && (isTablet || isMobile) && !isPWABannerDisabled,
    isShowInstructions: visiblePWAInstructions,
    onSetInstructions: SET_PWA_INSTRUCTIONS
  };
};
